import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

//Limitless imports
import { useExpertProfileContext, useAuthenticationContext, useLoginWrapperContext } from "../../expert";
import { POLICY_APP_INFO, POLICY_MFA_REQUIRED } from "../utils/CommonPolicyConstants";
import { usePortalRoutes } from "../hooks/portal-routes/PortalRoutesHook";
import LoginScreenLayout from "../components/forms/login/LoginScreenLayout";
const PortalLoginScreen = ({
  classes,
  onSignInSuccess,
  navItems
}) => {
  const {
    profile
  } = useExpertProfileContext();
  const {
    auth: {
      authenticated
    }
  } = useAuthenticationContext();
  const history = useHistory();
  const {
    getAuthorisedDestinationRoute,
    canUserAccess
  } = usePortalRoutes();
  const {
    mfaLoginState
  } = useLoginWrapperContext();
  React.useEffect(() => {
    if (authenticated && profile.userName) {
      if (typeof onSignInSuccess === "function") {
        onSignInSuccess();
      } else {
        var _profile$_phoneDetail;
        let destinationRoute = null;
        let payload;
        if (canUserAccess(POLICY_MFA_REQUIRED) && profile && !(profile !== null && profile !== void 0 && (_profile$_phoneDetail = profile._phoneDetails) !== null && _profile$_phoneDetail !== void 0 && _profile$_phoneDetail.isPhoneVerified)) {
          destinationRoute = "/mfa-setup";
          payload = {
            profile
          };
        } else if (canUserAccess(POLICY_APP_INFO)) {
          destinationRoute = "portal-selection";
        } else {
          destinationRoute = getAuthorisedDestinationRoute(navItems);
        }
        history.push({
          pathname: destinationRoute,
          state: payload
        });
      }
    }
  }, [authenticated, profile, mfaLoginState]);
  return /*#__PURE__*/React.createElement(LoginScreenLayout, {
    isManagerPortal: true,
    classes: classes
  });
};
export default PortalLoginScreen;
PortalLoginScreen.propTypes = {
  onSignInSuccess: PropTypes.func,
  navItems: PropTypes.array,
  classes: PropTypes.object
};